<template>
  <div class="addaccount-content">
    <el-header style="padding:0px;">
      <h3 class="title">
        <div class="block">
          <span><span @click="cancel()" style="cursor: pointer;">坐席管理</span>> {{title}}</span>
        </div>
      </h3>
    </el-header>
    <el-scrollbar style="height: calc(100% - 120px - 20px)">
        <el-form :model="accForm" label-width="110px" :rules="rules" ref="accForm" class="addform" :disabled="!$authUtis.hasButtonAuth('aicc-bp', '/user/addUser_post')">
          <el-form-item label="账号:" prop="userName">
            <el-input v-model="accForm.userName" :disabled="!!storeCurModUserId" placeholder="长度6-16个字，支持英文、数字" maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="工号:" prop="idNum">
            <el-input v-model="accForm.idNum" placeholder="长度2-10个字，支持英文、数字" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password">
            <el-input
              v-model="accForm.password"
              show-password
              placeholder="长度8-14个字，需包含大写字母、小写字母、数字及符号"
              maxlength="14"
              autocomplete="new-password"
              v-bind:readonly="isReadOnly"
              @focus="cancelReadOnly()"
            ></el-input>
          </el-form-item>
          <!-- 编辑账号，不显示 -->
          <el-form-item label="确认密码:" v-if="!storeCurModUserId" prop="confirmpwd">
            <el-input v-model="accForm.confirmpwd" show-password placeholder="请再次输入密码"></el-input>
          </el-form-item>
          <el-form-item label="昵称:" prop="nickname">
            <el-input
              v-model="accForm.nickname"
              placeholder="长度2-12个字，支持中文、英文、数字"
              maxlength="12"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用者:" prop="realName">
            <el-input
              v-model="accForm.realName"
              placeholder="长度2-10个字，支持中文、英文、数字"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input v-model="accForm.email" maxlength="40" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile">
            <el-input v-model.number="accForm.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="角色:" prop="roleId">
            <el-select v-model="accForm.roleId" placeholder="请选择所属角色">
              <el-option
                v-for="item in storeRolesData"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最大接待量:" prop="maxReception">
            <el-input
              v-model.number="accForm.maxReception"
              maxlength="2"
              placeholder="请输入1-30的整数"
            ></el-input>
          </el-form-item>
          <el-form-item label="分组:">
            <el-col :span="12">
              <TreeSelect
                class="filter-tree"
                :data="groupData_"
                :defaultProps="grouptreeProp"
                :filter-node-method="filterNode"
                :singleChange="changeTreeNode"
                :checkedKeys="checkedKeys"
                :selectNotLeafNode="true"
                ref="tree"
                style="width: auto"
              ></TreeSelect>
            </el-col>
            <el-col :span="12">
              <el-checkbox style="margin-left:10px" v-model="accForm.chargeGroup">坐席为该组负责人</el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item size="medium">
            <el-row type="flex" justify="center">
              <el-button size="medium" @click="cancel">取 消</el-button>
              <el-button type="primary" size="medium" @click="onSubmit">确 认</el-button>
            </el-row>
          </el-form-item>
        </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
import TreeSelect from '@/views/auth/components/treeSelect/TreeSelect'
import { addUser, getUser, getUserByProp } from '@/api/user'
import { mapActions } from 'vuex'
export default {
  name: '',
  data() {
    var validateMaxReception = (rule, value, callback) => {
      if (value <= 0 || value > 30) {
        callback(new Error('请输入1-30的整数'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value !== this.accForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateRemoteUserName = (rule, value, callback) => {
      getUserByProp({ id: this.accForm.id, idNum: null, userName: value })
        .then(res => {
          if (res.code === 2000) {
            if (res.data) {
              callback(new Error('存在重复账号:' + value))
            } else {
              callback()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    }
    var validateRemoteIdNum = (rule, value, callback) => {
      getUserByProp({ id: this.accForm.id, idNum: value, userName: null })
        .then(res => {
          if (res.code === 2000) {
            if (res.data) {
              callback(new Error('存在重复工号:' + value))
            } else {
              callback()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    }
    var validatePwd = (rule, value, callback) => {
      if (value === '••••••') {
        callback()
      } else {
        if (
          // 参考链接:https://www.jb51.net/article/167294.htm
          // (?=.*[A-Za-z])表示至少1个大写或小写字母、(?=.*\d)表示至少1个数字、(?=.*[$@!%*?&])表示至少有1个特殊字符，{6,16}表示6-16个长度
          // /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&].{8,14}$/.test(value) ||
          // /^(?=.*\d)(?=.*[$@!%*?&])[A-Za-z\d@$!%*?&].{8,14}$/.test(value) ||
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[$@!%*?&#^_-])(?=.*\d)[\da-zA-Z$@!%*?&#^_-]{8,14}$/.test(value)
        ) {
          // 如果包含了英文/数字/常用半角符号中的两项,则放行，否则认为密码强度不够
          callback()
        } else {
          callback(new Error('长度8-14个字，需包含大写字母、小写字母、数字及符号'))
        }
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (value && !/^\d{11}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      isReadOnly: true,
      showTree: false,
      accForm: {
        id: '',
        userName: '',
        idNum: '',
        password: '',
        confirmpwd: '',
        nickname: '',
        realName: '',
        email: '',
        mobile: '',
        roleId: '',
        maxReception: '',
        groupId: '',
        chargeGroup: false
      },
      rules: {
        // 账号
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 6, max: 16, message: '长度6-16个字，支持英文、数字', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z]+$/, message: '仅支持英文、数字', trigger: 'blur' },
          { validator: validateRemoteUserName, trigger: 'blur' }
        ],
        // 工号
        idNum: [
          { required: true, message: '请输入工号', trigger: 'blur' },
          { min: 2, max: 10, message: '长度2-10个字，支持英文、数字', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z]+$/, message: '仅支持英文、数字', trigger: 'blur' },
          { validator: validateRemoteIdNum, trigger: 'blur' }
        ],
        // 密码
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }
        ],
        // 确认密码
        confirmpwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        // 昵称
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 2, max: 12, message: '长度2-12个字，支持中文、英文、数字', trigger: 'blur' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: '仅支持中文、英文、数字',
            trigger: 'blur'
          }
        ],
        // 使用者
        realName: [
          { required: true, message: '请输入使用者', trigger: 'blur' },
          { min: 2, max: 10, message: '长度2-10个字，支持中文、英文、数字', trigger: 'blur' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: '仅支持中文、英文、数字',
            trigger: 'blur'
          }
        ],
        // 邮箱
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        // 手机号
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        // 角色
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        // 最大接待量
        maxReception: [
          {
            required: true,
            // pattern: /^([1-9]|10)$/,
            pattern: /^[0-9]+$/,
            message: '请输入1-30的整数',
            trigger: 'blur'
          },
          { validator: validateMaxReception, trigger: 'blur' }
        ]
      },
      checkedKeys: [],
      groupId: '',
      title: ''
    }
  },
  watch: {
    curGroupId(val) {
      this.groupId = val
    }
  },
  props: {
    changeView: Function,
    grouptreeProp: Object,
    curGroupId: String
  },
  components: {
    TreeSelect
  },
  mounted() {
    this.showTitle()
  },
  computed: {
    groupData_() {
      return this.$store.state.user.userGroupTree
    },
    storeRolesData() {
      return this.$store.state.role.rolesData
    },
    storeCurModUserId() {
      return this.$store.state.user.curModUserId
    },
    showPassword() {
      return !this.storeCurModUserId
    }
  },
  methods: {
    ...mapActions('user', ['_listUser']),
    showTitle() {
      // 新建坐席账号
      if (this.storeCurModUserId) {
        this.title = '编辑坐席账号'
        getUser(this.storeCurModUserId)
          .then(res => {
            if (res.code === 2000) {
              const data = res.data
              this.accForm.id = data.id
              this.accForm.userName = data.userName
              this.accForm.idNum = data.idNum
              this.accForm.password = '••••••'
              this.accForm.nickname = data.nickname
              this.accForm.realName = data.realName
              this.accForm.email = data.email
              this.accForm.mobile = data.mobile
              this.accForm.roleId = data.roleId
              this.accForm.maxReception = data.maxReception
              this.accForm.groupId = data.userGroupId
              this.checkedKeys.push(data.userGroupId)
              this.accForm.chargeGroup = data.charge
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      } else {
        this.title = '新建坐席账号'
      }
    },
    changeTreeNode(node) {
      this.accForm.groupId = node
    },
    changeShow() {
      this.showTree = true
    },
    onSubmit() {
      const that = this
      that.$refs.accForm.validate(valid => {
        // 表单校验通过,提交到后端
        if (valid) {
          addUser(this.accForm).then(res => {
            if (res.code === 2000) {
              // this._listUser({ groupId: '' })
              that.$message.success(res.data)
              that.changeViewAdd(true)
            } else {
              that.$message.error(res.msg)
            }
          })
        } else {
          // 表单校验不通过,驳回重新填写
          return false
        }
      })
    },
    cancel() {
      this.changeViewAdd(true)
    },
    changeViewAdd(target) {
      this.changeView(target)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    cancelReadOnly() {
      this.isReadOnly = false
    }
  }
}
</script>
<style lang="scss" scoped>
.addform {
  width: 60%;
  /* text-align: center; */

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100%;
  }
}
.el-aside {
  color: #333;
  height: 100%;
}
.zxtitle {
  line-height: 40px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

.addaccount-content {
  margin: 0;
  padding: 0;
  height: 100%;
  & > .el-container {
    & > .el-main {
      padding: 10px 20px;

      .el-select {
        &.tree-select {
          .el-input--small {
            .el-input__inner {
              height: 40px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
.side {
  width: 200px !important;
  margin-top: 10px;
  padding-right: 20px;
  border-right: 1px solid #ebebeb;
}
</style>
<style lang="scss">
.addaccount-content {
  .el-select {
    &.tree-select {
      width: 100%;
      .el-input--small {
        .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }
}
</style>
